import { useLanguageStore } from '$/store/languageStore';

// 默认中文水印图片地址的七牛 urlsafe Base64，原始地址为 RoboNeo 内置水印资源。
const DEFAULT_CN_WATERMARK_BASE64 = 'aHR0cHM6Ly90aXRhbi1oNS5tZWl0dS5jb20vcm9ib25lby9hc3NldHMvY25fd2F0ZXJfM3gucG5n';
// 默认英文（非中文）水印图片地址的七牛 urlsafe Base64。
const DEFAULT_EN_WATERMARK_BASE64 = 'aHR0cHM6Ly90aXRhbi1oNS5vYnMuY24tbm9ydGgtNC5teWh1YXdlaWNsb3VkLmNvbS9yb2JvbmVvL2Fzc2V0cy9lbl93YXRlcl8zeC5wbmc';
const WATERMARK_PARAMS = 'gravity/SouthWest/ws/0.07';

let customWatermarkBase64 = '';

/**
 * 判断当前语言是否为中文（简体/繁体）。
 */
function isChinese() {
  const { languageCode } = useLanguageStore.getState().languageStore;
  return languageCode === 'zh-Hans' || languageCode === 'zh-Hant' || languageCode === 'zh';
}

/**
 * 设置 handleImageUrl 使用的合规水印 Base64；传空时恢复内置水印。
 */
export function setCloudWatermarkBase64(watermarkBase64?: string) {
  customWatermarkBase64 = watermarkBase64 || '';
}

/**
 * 获取图片云处理所需的水印参数，支持 InitComponent 注入的宿主水印。
 * 优先使用宿主自定义水印；未自定义时根据当前语言选择中文或英文水印。
 */
export function getCloudWatermarkFormat() {
  const defaultBase64 = isChinese() ? DEFAULT_CN_WATERMARK_BASE64 : DEFAULT_EN_WATERMARK_BASE64;
  return `watermark/1/image/${customWatermarkBase64 || defaultBase64}/${WATERMARK_PARAMS}`;
}
